import React from "react";
import LoginAndSignup from "./AuthForm";
import AuthWrapper from "./AuthWrapper";
import { Helmet } from "react-helmet";

const LoginComp = () => {
  return (
    <>
      <Helmet>
        <title>Login | WafyNet - Access Your Account</title>
        <meta
          name="description"
          content="Securely login to your WafyNet account to explore jobs, grow your network, and manage your business opportunities."
        />
      </Helmet>
      <AuthWrapper>
        <LoginAndSignup />
      </AuthWrapper>
    </>
  );
};

export default LoginComp;
